import { jwtDecode } from 'jwt-decode';

/**
 * Whether a token is present, readable and not expired. It does not say the server accepts it:
 * only `/me` can.
 *
 * Never throws. `jwtDecode` does on anything that is not a JWT, and this is now also read during
 * the guard's render, where a corrupted value in storage must mean "not signed in", not a crash.
 */
export const isValidToken = (accessToken: string | null | undefined) => {
  if (!accessToken) return false;
  try {
    const decoded = jwtDecode<{ exp: number }>(accessToken);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch {
    return false;
  }
};
